// Mock data for AutoBudgetAI frontend development
export interface Transaction {
  id: string;
  amount: number;
  category: string;
  description: string;
  merchant: string;
  date: string;
}

export interface CategorySpending {
  category: string;
  amount: number;
  color: string;
  percentage: number;
  targetPercentage?: number;
  limitAmount?: number;
}

export interface DashboardStats {
  totalSpent: number;
  monthlyBudget: number;
  monthlyIncome?: number;
  recentTransactions: Transaction[];
  categorySpending: CategorySpending[];
}

// Default household for the application
export const defaultHousehold = {
  id: 'household-1',
  name: 'Personal',
  currency: 'USD'
};

// Mock categories with colors
export const mockCategories = [
  { id: 'cat-1', name: 'Food & Dining', color: '#FF6B6B', isFixed: false },
  { id: 'cat-2', name: 'Transportation', color: '#4ECDC4', isFixed: false },
  { id: 'cat-3', name: 'Shopping', color: '#45B7D1', isFixed: false },
  { id: 'cat-5', name: 'Bills & Utilities', color: '#FFEAA7', isFixed: true },
];

// Mock transactions
export const mockTransactions: Transaction[] = [
  {
    id: 'tx-1',
    amount: 45.67,
    category: 'Food & Dining',
    description: 'Lunch at Italian restaurant',
    merchant: 'Mario\'s Restaurant',
    date: '2025-11-20'
  },
  {
    id: 'tx-2',
    amount: 120.00,
    category: 'Bills & Utilities',
    description: 'Monthly electricity bill',
    merchant: 'PowerCo Electric',
    date: '2025-11-19'
  },
  {
    id: 'tx-3',
    amount: 15.50,
    category: 'Transportation',
    description: 'Gas station',
    merchant: 'Shell Gas Station',
    date: '2025-11-18'
  },
  {
    id: 'tx-4',
    amount: 89.99,
    category: 'Shopping',
    description: 'Winter jacket',
    merchant: 'Fashion Store',
    date: '2025-11-17'
  },
  {
    id: 'tx-6',
    amount: 75.50,
    category: 'Food & Dining',
    description: 'Grocery shopping',
    merchant: 'SuperMart',
    date: '2025-11-15'
  },
  {
    id: 'tx-8',
    amount: 12.30,
    category: 'Transportation',
    description: 'Bus fare',
    merchant: 'City Transit',
    date: '2025-11-13'
  }
];

// Calculate dashboard statistics
export const mockDashboardStats: DashboardStats = {
  totalSpent: 358.96,
  monthlyBudget: 1500.00,
  monthlyIncome: 3000.00,
  recentTransactions: mockTransactions,
  categorySpending: [
    { category: 'Food & Dining', amount: 121.17, color: '#FF6B6B', percentage: 24.3, targetPercentage: 20, limitAmount: 500 },
    { category: 'Transportation', amount: 27.80, color: '#4ECDC4', percentage: 5.6, targetPercentage: 10, limitAmount: 200 },
    { category: 'Shopping', amount: 89.99, color: '#45B7D1', percentage: 18.0, targetPercentage: 15 },
    { category: 'Bills & Utilities', amount: 120.00, color: '#FFEAA7', percentage: 24.1, targetPercentage: 30, limitAmount: 150 },
  ]
};

// User profile mock
export const mockUser = {
  id: 'user-1',
  displayName: 'John Doe',
  email: 'john@example.com',
  currentPlan: 'free' as 'free' | 'premium'
};